import axios from "axios";
import CampaignInterface from "../stores/CampaignInterface";

declare global {
    interface Window {
        before: any;
        after: any;
    }

    interface String {
        replaceAt(index: number, char: string): string;
    }
}


export class WpexApi {

    BASE_URL = process.env.NODE_ENV === 'production' ? window.location.protocol + "//" + window.location.host + window.location.pathname.split('/').slice(0,window.location.pathname.split('/').length-1).join('/') : 'http://wewp-plugins/wp-admin';

    mailchimpConfig: any = {};

    constructor() {
        this.getMailchimpConfig();
    }

    async getShortCode(){
        try {

            const {data} = await axios.post(`${this.BASE_URL}/admin-ajax.php`, `action=wpex_get_short_code`, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            });

            return data;
        } catch (e) {
            console.warn('Error: WpexApi->getLocale', e);
        }
    }

    async getLocale() {
        try {

            const {data} = await axios.post(`${this.BASE_URL}/admin-ajax.php`, `action=wpex_get_locale`, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            });

            return data;
        } catch (e) {
            console.warn('Error: WpexApi->getLocale', e);
        }
    }

    async getMailchimpConfig() {
        try {
            let toSend: any = {
                action: 'wpex_get_mailchimp_config',
            };

            const {data} = await axios.post(`${this.BASE_URL}/admin-ajax.php`, this.jqueryParam(toSend), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            });

            this.mailchimpConfig = data;
        } catch (e) {
            console.warn('Error: WpexApi->getMailchimpConfig', e);
        }
    }

    async saveCampaign(campaign: CampaignInterface) {
        try {

            let toSend: any = {
                action: 'wpex_save_campaign',
                campaign: campaign,

            };

            const {data} = await axios.post(`${this.BASE_URL}/admin-ajax.php`, this.jqueryParam(toSend), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            });

            return data;
        } catch (e) {
            console.warn('Error: WpexApi->saveCampaign', e);
        }
    }


    async loadCampaigns(): Promise<CampaignInterface[]> {

        let campaigns: CampaignInterface[] = [];

        try {

            const {data} = await axios.post(`${this.BASE_URL}/admin-ajax.php`, `action=wpex_get_campaign`, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            });

            campaigns = data.campaigns;
        } catch (e) {
            console.warn('Error: WpexApi->loadCampaings', e);
        }

        return campaigns;
    }

    async getMailchimpLists() {
        try {
            const {data} = await axios.post(`${this.BASE_URL}/admin-ajax.php`, 'action=wpex_get_mailchimp_lists');

            //#TODO  check if lists exist
            return data.lists;
        } catch (e) {
            console.log('Error to get mailchimp list', e);
        }
    }

    async sendTest(campaign: CampaignInterface, emails: []) {
        try {
            const dataToSend = {
                action: 'wpex_send_campaign_test',
                campaign: campaign,
                emails: emails,
            };
            return await axios.post(`${this.BASE_URL}/admin-ajax.php`, `${this.jqueryParam(dataToSend)}`);

        } catch (e) {
            console.log('Error to get mailchimp list', e);
        }
    }

    async send(campaign: CampaignInterface) {
        try {
            const dataToSend = {
                action: 'wpex_send_campaign',
                campaign: campaign,
            };

            return await axios.post(`${this.BASE_URL}/admin-ajax.php`, `${this.jqueryParam(dataToSend)}`);

        } catch (e) {
            console.log('Error to get mailchimp list', e);
        }
    }

    async getCampaignByPostId(post_id: number) {
        try {
            const {data} = await axios.post(`${this.BASE_URL}/admin-ajax.php`, `action=wpex_get_campaign&post_id=${post_id}`);
            return data.campaign;
        } catch (e) {
            console.log('Error to get mailchimp list', e);
        }
    }

    jqueryParam(a: any) {
        const s: any[] = [];

        const add = (k: any, v: any) => {
            v = typeof v === 'function' ? v() : v;
            v = v === null ? '' : v === undefined ? '' : v;
            s[s.length] = encodeURIComponent(k) + '=' + encodeURIComponent(v);
        };

        const buildParams = function (prefix: any, obj: any) {
            let i, len, key;

            if (prefix) {
                if (Array.isArray(obj)) {
                    for (i = 0, len = obj.length; i < len; i++) {
                        buildParams(
                            prefix + '[' + (typeof obj[i] === 'object' && obj[i] ? i : '') + ']',
                            obj[i]
                        );
                    }
                } else if (String(obj) === '[object Object]') {
                    for (key in obj) {
                        buildParams(prefix + '[' + key + ']', obj[key]);
                    }
                } else {
                    add(prefix, obj);
                }
            } else if (Array.isArray(obj)) {
                for (i = 0, len = obj.length; i < len; i++) {
                    add(obj[i].name, obj[i].value);
                }
            } else {
                for (key in obj) {
                    buildParams(key, obj[key]);
                }
            }
            return s;
        };

        return buildParams('', a).join('&');
    }
}
